import React from 'react';
import { Body5, Container } from '@ui';
import { NodeParameterRemoveButton } from '@flow/buttons/NodeParameterRemoveButton';
import { AgentFlowParameterWrapper, AgentFlowParameterLabelWrapper } from '@flow/styles';
import { SkeletonButton } from '@ui/buttons/SkeletonButton';
import { TransparentFlatButton } from '@ui/buttons';
import styled from 'styled-components';

const DocItemWrapper = styled.div`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CsvDocSelectionParameter = ({ data, value, onRemove, onChange, openCsvDocSelectionModal }) => {
  const { keyName, label } = data;

  const [selectedDocs, setSelectedDocs] = React.useState(() => {
    if (!Array.isArray(value) || !value.length) return [];
    return value.map((id) => (typeof id === 'object' && id !== null ? id : { id }));
  });

  React.useEffect(() => {
    onChange(keyName, selectedDocs.map((d) => d.id));
  }, [selectedDocs]);

  const handleOpenModal = () => {
    openCsvDocSelectionModal(selectedDocs, (newDocs) => {
      setSelectedDocs(newDocs);
    });
  };

  const handleRemoveItem = (docId) => {
    setSelectedDocs((prev) => prev.filter((d) => d.id !== docId));
  };

  const handleRemoveAll = () => {
    setSelectedDocs([]);
  };

  const handleRemoveClick = () => onRemove(keyName);

  return (
    <AgentFlowParameterWrapper style={{ flexDirection: 'column', alignItems: 'flex-start', minHeight: 'auto' }}>
      <Container fullWidth>
        <Container row verticallyCenter spaceBetween fullWidth>
          <Container row verticallyCenter>
            <AgentFlowParameterLabelWrapper>
              <Body5>{label}:</Body5>
            </AgentFlowParameterLabelWrapper>
            <div className="read-only-hide">
              <SkeletonButton onClick={handleOpenModal}>Select CSV Data</SkeletonButton>
            </div>
          </Container>
          <NodeParameterRemoveButton onClick={handleRemoveClick} />
        </Container>
        {selectedDocs.length > 0 && (
          <ul>
            {selectedDocs.map((doc) => (
              <li key={doc.id}>
                <Container fullWidth row verticallyCenter>
                  <DocItemWrapper>
                    <Body5>{doc.filename || `Doc #${doc.id}`}</Body5>
                  </DocItemWrapper>
                  <NodeParameterRemoveButton onClick={() => handleRemoveItem(doc.id)} />
                </Container>
              </li>
            ))}
          </ul>
        )}
        {selectedDocs.length > 0 && (
          <div className="read-only-hide">
            <TransparentFlatButton onClick={handleRemoveAll}>Remove All</TransparentFlatButton>
          </div>
        )}
      </Container>
    </AgentFlowParameterWrapper>
  );
};
